var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStickyNoteChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sticky-note",
    "data-name": "Icon awesome-sticky-note",
    d: "M21.938,22.5H31.5V3.938A1.683,1.683,0,0,0,29.813,2.25H1.688A1.683,1.683,0,0,0,0,3.938V32.063A1.683,1.683,0,0,0,1.688,33.75H20.25V24.188A1.692,1.692,0,0,1,21.938,22.5Zm9.07,3.867-6.891,6.891a1.686,1.686,0,0,1-1.2.492H22.5v-9h9v.429A1.682,1.682,0,0,1,31.008,26.367Z",
    transform: "translate(0 -2.25)",
    fill: "#1a78f3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNoteChat);
export default __webpack_public_path__ + "static/media/sticky_note_chat.1157f7e4d78a37fd0a78035b32723d15.svg";
export { ForwardRef as ReactComponent };